var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3641 21H11.1823C10.279 21 9.5459 20.2669 9.5459 19.3636V11.1818C9.5459 10.2785 10.279 9.54541 11.1823 9.54541H19.3641C20.2674 9.54541 21.0004 10.2785 21.0004 11.1818V19.3636C21.0004 20.2669 20.2674 21 19.3641 21Z",
    stroke: "#5F698B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27273 14.4545H4.63636C3.73309 14.4545 3 13.7215 3 12.8182V4.63636C3 3.73309 3.73309 3 4.63636 3H12.8182C13.7215 3 14.4545 3.73309 14.4545 4.63636V6.27273",
    stroke: "#5F698B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.6afab0829291e9db5a718cc2f58ed4ca.svg";
export { ForwardRef as ReactComponent };